import React, { useState, useEffect, useMemo, useRef, Suspense } from 'react'
import { Canvas, Dom, extend, useLoader, useThree, useFrame } from '@react-three/fiber'
import * as THREE from 'three';
import { useSpring, useSprings, a } from '@react-spring/three'
//import { Billboard, RoundedBox} from '@react-three/drei'
//import { Billboard } from '@react-three/drei/Billboard'
//import { RoundedBox } from '@react-three/drei/RoundedBox'

import {
  useAudioStore,
  useSceneStore,
} from '../store'


// Desaturate the map before material-color multiply so tint replaces hue.
// uGreyscale: 1 = full greyscale (ready to tint), 0 = original image color.
// Luma uses Rec.709 linear coefficients (texture is decoded to linear above).
const applyGreyscaleBeforeTint = (shader) => {
  shader.uniforms.uGreyscale = { value: 1 }
  shader.fragmentShader = 'uniform float uGreyscale;\n' + shader.fragmentShader.replace(
    '#include <map_fragment>',
    /* glsl */ `
    #ifdef USE_MAP
      vec4 texelColor = texture2D( map, vUv );
      texelColor = mapTexelToLinear( texelColor );
      float luma = dot(texelColor.rgb, vec3(0.2126, 0.7152, 0.0722));
      texelColor.rgb = mix(texelColor.rgb, vec3(luma), uGreyscale);
      diffuseColor *= texelColor;
    #endif
    `
  )
}

const ImagePanel = ({ type, currentColor, layout, url, args, ...props }) => {
    const texture = useMemo(() => {
      const tex = new THREE.TextureLoader().load('/assets/images/'+url)
      // Required with R3F colorManagement — otherwise sRGB thumbs are treated as
      // linear and look washed out when multiplied by white (untinted state).
      tex.encoding = THREE.sRGBEncoding
      return tex
    }, [url]);
    const materialRef = useRef()

   
    const { mode, filterGrid} = useSceneStore(state => state)

    const mobile = window.innerWidth < 700;
    const isUntinted = filterGrid === type && mode === 'grid'
  
  
    // yuck -- opacity as own spring, which doesn't work. Switching on and off now
  //  const [opacityState, setOpacityState] = useState(layout)
    const [hoverState, setHoverState] = useState(false);
    //const [filterState, setFilterState] = useState(null)

    //const [active, setActive] = useState(false)
    const [hovered, setHover] = useState(false)

  
/*
    useEffect(() => {
      console.log('filterGrid', filterGrid)
      console.log('type', type)
      console.log('mode', mode)
     // document.body.style.cursor = hoverState ? 'pointer' : 'move'
    }, [])
*/
    const { greyscale, ...props2 } = useSpring({
      //  'material-color': (filterGrid === type && mode==='grid' ) ? 'white' : currentColor,
       // color: (filterGrid === type && mode==='grid' ) ? 'white' : currentColor,

        'material-color': isUntinted ? '#ffffff' : currentColor,
        // Untinted (filtered) panels restore original color; tinted stay greyscaled
        greyscale: isUntinted ? 0 : 1,
       // color: currentColor,
       // pos: active ? [0, 0, 2] : [0, 0, 0],
     //   'material-opacity': hovered ? 1 : 0.25,
     scale: hovered ? [args[0]*1.1,args[1]*1.1,args[2]*1.1] : (isUntinted && !mobile) ? args : [args[0]*.75,args[1]*.75,args[2]*.75],
   //     scale: hovered ? [args[0]*1.1,args[1]*1.1,args[2]*1.1] : args ,
     //   rotation: active ? [THREE.Math.degToRad(180), 0, THREE.Math.degToRad(45)] : [0, 0, 0],
        config: { mass: 10, tension: 1000, friction: 300, precision: 0.00001 },
      })

    useFrame(() => {
      const shader = materialRef.current?.userData?.shader
      if (shader?.uniforms?.uGreyscale) {
        shader.uniforms.uGreyscale.value = greyscale.get()
      }
    })
    /*
    const { opa } = useSpring({
      opacity: (opacityState === 'grid') ? 1 : .3,
      config: { mass: 100, tension: 50, friction: 50 },
      //config: SPRING_CONFIG,
      // onRest: () => setIdle((state) => !state),
      // onStart: () => setIdle((state) => !state),
    });
    */
   /*
   const scaleSpring  = useSpring({
      scale: (hoverState) ? [args[0]*1.1, args[1]*1.1, args[2]*1.1] : args,
      config: { mass: 100, tension: 50, friction: 50 },
      //config: SPRING_CONFIG,
      // onRest: () => setIdle((state) => !state),
       onStart: () => {console.log('start scaleSpring')},
    } );
  
    useEffect(() => {
      //console.log('hoverstate', hoverState)
    }, [hoverState])
    */
  /*
    useEffect(() => {
      
     setOpacityState(layout)
    }, [layout])
  */
 /*
    useEffect(() => {
  
     setFilterState(filter)
    }, [filter])
*/
    return (
      <a.group {...props}>
        
      <a.sprite
       // scale={(hoverState ? [args[0]*1.05,args[1]*1.05,args[2]*1.05] : args)}
        //scale={scaleSpring.scale}
        //onPointerOver={() => setHoverState(true)}
        //onPointerOut={() => setHoverState(false)}
        //onClick={e => setActive(!active)} 
        onPointerOver={e => {if (mode==='grid') setHover(true)}} 
        onPointerOut={e => {if (mode==='grid') setHover(false)}}
        onUpdate={(self) => {
          // Background camera layer (CanvasScene BG_LAYER = 1)
          if (self.layers.mask !== (1 << 1)) self.layers.set(1)
        }}
        {...props2}
      >
     
        <spriteMaterial
          ref={materialRef}
          attach="material"
          map={texture}
          onBeforeCompile={(shader) => {
            applyGreyscaleBeforeTint(shader)
            if (materialRef.current) {
              materialRef.current.userData.shader = shader
              shader.uniforms.uGreyscale.value = isUntinted ? 0 : 1
            }
          }}
          customProgramCacheKey={() => 'imagePanel-greyscale-tint'}
        />
     
      {/*  <planeBufferGeometry attach="geometry" args={args} />
        <meshLambertMaterial attach="material">
          <primitive attach="map" object={texture} />
        </meshLambertMaterial>*/}
      </a.sprite>
      {/*
      <Billboard
        position={[4, -2, 0]}
        args={args}
      
        material-color={"blue"}
        map={texture}
        follow={true}
        lockX={false}
        lockY={false}
        lockZ={false}
      />
      */}
      {/*
      <RoundedBox
        position={[0, 0, -1]}
      //  material-color={'yellow'}
        args={[args[0]*1.1,args[1]*1.1,1]} // Width, Height and Depth of the box
        radius={2} // Border-Radius of the box
        smoothness={4} // Optional, number of subdivisions
        // {...meshProps} // All THREE.Mesh props are valid
        >
        <a.meshBasicMaterial attach="material" color={color}/>
        </RoundedBox>
      */}
      </a.group>
    );
  };

  export default ImagePanel;